import React, { useState } from "react";
import DomainSeoHelmet from "../agentic/DomainSeoHelmet";
import DomainHiddenSeoContent from "../agentic/DomainHiddenSeoContent";
import DomainUseCaseCard, { DOMAIN_PAGE_STYLES } from "../agentic/domainUseCaseLayout";
import UseCaseIndexGrid from "../agentic/UseCaseIndexGrid";
import RpaProcessFlow from "./RpaProcessFlow";
import {
  AGRICULTURE_DOMAIN_INTRO,
  AGRICULTURE_GROUPS,
  AGRICULTURE_USE_CASES_SEO,
  AGRICULTURE_DOMAIN_FAQS,
  AGRICULTURE_ITEM_LIST_JSONLD,
  AGRICULTURE_BREADCRUMB_JSONLD,
  AGRICULTURE_WEBPAGE_JSONLD,
  AGRICULTURE_FAQ_JSONLD,
} from "../../data/rpa/agriculture-food-processing-domainUseCases";

function UseCaseCard({ useCase }) {
  return (
    <DomainUseCaseCard
      useCase={useCase}
      flow={<RpaProcessFlow useCase={useCase} />}
    />
  );
}

function GroupSection({ group }) {
  const cases = AGRICULTURE_USE_CASES_SEO.filter((uc) => uc.groupId === group.id);
  if (!cases.length) return null;
  return (
    <section id={group.id} className="fin-section" aria-labelledby={`${group.id}-heading`}>
      <h2 id={`${group.id}-heading`}>{group.label}</h2>
      <div className="fin-list">
        {cases.map((uc) => (
          <UseCaseCard key={uc.id} useCase={uc} />
        ))}
      </div>
    </section>
  );
}

export default function AgricultureRpaDomainContent() {
  const [activeFilter, setActiveFilter] = useState("all");
  const visibleGroups =
    activeFilter === "all"
      ? AGRICULTURE_GROUPS
      : AGRICULTURE_GROUPS.filter((group) => group.id === activeFilter);

  return (
    <div className="fin-page">
      <DomainSeoHelmet
        intro={AGRICULTURE_DOMAIN_INTRO}
        domainSlug="agriculture-food-processing-domain"
        basePath="/rpa-use-cases"
        useCaseCount={AGRICULTURE_USE_CASES_SEO.length}
        groupCount={AGRICULTURE_GROUPS.length}
        itemListJsonLd={AGRICULTURE_ITEM_LIST_JSONLD}
        faqJsonLd={AGRICULTURE_FAQ_JSONLD}
        breadcrumbJsonLd={AGRICULTURE_BREADCRUMB_JSONLD}
        webPageJsonLd={AGRICULTURE_WEBPAGE_JSONLD}
        keywords="Agriculture & Food Processing automation, document AI + RPA, workflow automation, robotic process automation India UAE KSA UK USA"
        sectionLabel=""
      />
      <style>{DOMAIN_PAGE_STYLES}</style>
      <header className="fin-hero">
        <div className="fin-hero-inner">
          <h1>{AGRICULTURE_DOMAIN_INTRO.title}</h1>
          {AGRICULTURE_DOMAIN_INTRO.content ? <p>{AGRICULTURE_DOMAIN_INTRO.content}</p> : null}
        </div>
      </header>
      <UseCaseIndexGrid
        useCases={AGRICULTURE_USE_CASES_SEO}
        groups={AGRICULTURE_GROUPS}
        heading="Agriculture & Food Processing Use Cases"
        onFilterChange={setActiveFilter}
      />
      <div className="fin-wrap">
        {visibleGroups.map((group) => (
          <GroupSection key={group.id} group={group} />
        ))}
      </div>
      <DomainHiddenSeoContent
        domainTitle={AGRICULTURE_DOMAIN_INTRO.title}
        domainFaqs={AGRICULTURE_DOMAIN_FAQS}
        useCases={AGRICULTURE_USE_CASES_SEO}
      />
    </div>
  );
}

